@if (isReady) {
  <div>
    <div class="text-center">
      <b>{{(orderOnBehalfService.customerAsObservable() | async)?.Name}}</b>
      <p>{{ 'STARTKITS.DOESNOTCARRYPRODUCTLINE' | translate }}</p>
    </div>
    <p class="text-center">{{ 'STARTKITS.WOULDYOULIKESTARTKIT' | translate }}</p>
    <div class="flex flex-column flex-center">
      <div class="flex flex-column buttons">
        @for (startKit of startkits; track startKit) {
          <button class="btn btn-primary" (click)="addStartkit(startKit)">{{ startKit.Description }}</button>
        }
        <button class="btn btn-secondary" (click)="addStartkit(undefined)">{{ 'COMMON.CANCEL' | translate }}</button>
      </div>
    </div>
  </div>
}